/**
 * @generated SignedSource<<67b07f8689598c97cf8c95ccd1642b6d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedVisuallySimilarItemsCarousel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedProductTileCarousel_user">;
  readonly " $fragmentType": "PdpSharedVisuallySimilarItemsCarousel_user";
};
export type PdpSharedVisuallySimilarItemsCarousel_user$key = {
  readonly " $data"?: PdpSharedVisuallySimilarItemsCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedVisuallySimilarItemsCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedVisuallySimilarItemsCarousel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedProductTileCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "392718262c8f831ab711b6422e23335d";

export default node;
